import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Contact from './pages/Contact';
import Projects from './pages/Projects';
import './App.css';
import Reviews from './pages/Reviews';
import About from './pages/About';
import Apply from './pages/Apply';
import Admin from './pages/Admin';
import { useLocation } from "react-router-dom";
import Pricing from './pages/Pricing';
const App = () => {
  const location = useLocation();
  const hideHeaderRoutes = ["/apply"];

  const shouldHideHeader = hideHeaderRoutes.includes(location.pathname);

  return (
    <>
      {!shouldHideHeader && <Header />}
      <main className="content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/about" element={<About />} />
          <Route path="/apply" element={<Apply />} />
             <Route path="/pricing" element={<Pricing />} />
          <Route path="/adsfkascmaokcanasfljnlcala" element={<Admin />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
};

export default App;
